import { useLazyQuery } from "@apollo/client/react";import React, { Fragment, useEffect } from "react";
import CardBox from "../../CardBox/CardBox";
import InfoRow from "../../InfoRow/InfoRow";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Grid } from
"@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';

import { GET_PROFESIONALES_BY_VISITA, parseProfesionalesByVisita } from "../../../../../../data/graphQL/queries/MisVisitas/getProfesionalesByVisita";

export default function Profesionales({ visita, setVisita, idEvaluacion }) {

  const { profesionales = [] } = visita;

  const [getProfesionales, { data: dataProfesionales, loading: loadingProfesionales }] = useLazyQuery(GET_PROFESIONALES_BY_VISITA);

	useEffect(() => {
		if (!dataProfesionales) return;
    setVisita((prev) => ({
      ...prev,
      profesionales: parseProfesionalesByVisita(dataProfesionales)
    }));
	}, [dataProfesionales]);  

  useEffect(() => {
    if (!idEvaluacion) return;
    getProfesionales({ variables: { idEvaluacion } });
  }, [idEvaluacion]);


  if (!profesionales.length && !loadingProfesionales) {
    return (
      <CardBox>
                <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                    No hay profesionales cargados.
                </p>
            </CardBox>);

  }

  return (
    <CardBox>
            {profesionales.map((prof, idx) =>
      <Fragment key={idx}>
                    <Accordion key={idx} disableGutters elevation={0} square sx={{ '&:before': { display: 'none' } }}>
                        <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            sx={{
              paddingY: 0,
              minHeight: 'auto',
              '& .MuiAccordionSummary-content': {
                margin: 0
              }
            }}>
            
                            <InfoRow label="Tipo de profesional" value={prof.tipoProfesional} />
                        </AccordionSummary>
                        <AccordionDetails sx={{ paddingTop: 0, paddingBottom: 0 }}>
                            <Grid container>
                                <InfoRow label="Nombre" value={`${prof.nombre} ${prof.apellido}`} />
                                <InfoRow label="Rol" value={prof.rol} />
                                <InfoRow
                label="Fecha Asignación"
                value={`${prof.fechaAsignacionDesde} - ${prof.fechaAsignacionHasta}`} />
              
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    {idx < profesionales.length - 1 && <Divider />}
                </Fragment>
      )}
        </CardBox>);

}